import { LocaleData, LocaleConfig } from '../types';

export const config: LocaleConfig = {
    id: 'qu',
    fullName: 'Quechua',
    nativeName: 'Runasimi',
    direction: 'ltr'
};

const translations: LocaleData = {
    title: "ArgVoid nisqa",
    landing_title: "Imapas Musphaymi Hamuchkan",
    landing_subtitle: "ArgVoid nisqaqa huk app chaymanta pukllay wiñachiy estudiom. ¡Qhawariychik, musuq imakunam chayamuchkan!",
    select_language: "Simita akllay",
    search_placeholder: "Simikunata maskay...",
    terms_title: "Serviciomanta kamachiykuna",
    policy_title: "Sapanchasqa willakuy",
    cookies_title: "Cookies nisqamanta kamachiy",
    terms_content: `
        <strong>1. Términos nisqakunata chaskiy</strong><br>
        ArgVoid kaqman yaykuspa, kay Yanapakuypa Términosnin chaskisqa kanku. Sichus kay términos mana acuerdopichu kanku, serviciota mana llamk'achinachu tiyan.<br><br>

        <strong>2. Plataformapa Uso</strong><br>
        ArgVoid chaymanta ruwanakuna "imaynachus kachkan" willaypaq chaymanta kamaypaq qusqa. Servicioqa kamachiyman hina ruwanapaqlla llamk'achinan tiyan.<br><br>

        <strong>3. Hark’asqa Ruway</strong><br>
        Sitio mana allin ruwaykunata aprovechay, spam utaq mana kamachisqa infraestructuraman yaykuyta munaspaqa sinchita hark'asqa.<br><br>

        <strong>4. Mana ruway atiy</strong><br>
        Plataforma chaymanta serviciokuna mayk'aqllapas mana willayniyuq tikrasqa kankuman. Mana garantia qusqachu pacha llamk'aymanta utaq servicio kasqanmanta.
    `,
    policy_content: `
        <strong>1. Willakuy Huñusqa</strong><br>
        Plataforma mana kay pachapi user chiqaqchayta utaq yupay ruwayta munanchu. Mana sapalla riqsichiy willakuy (aswan sutikuna utaq correo electrónico direccionkuna) ruwaqkunamanta ruwasqachu.<br><br>

        <strong>2. Uso Datos</strong><br>
        Sapsi, mana sutiyuq t'aqwiykuna huñusqa kanman sitio puriyta hamut'anapaq chaymanta ruwanakuna allinchaypaq. Kay willakuyqa manam sapalla ruwaqpa riqsichiyninkunawan tinkisqachu.<br><br>

        <strong>3. Kimsa kaq Serviciokuna</strong><br>
        Kimsa kaq quqkuna qunakuypaq chaymanta t'aqwiypaq yanapakuykunapaq llamk'achinkuman. Kay sapan quqpa sapanchasqa ruwayninkuna kamachin mana sutiyuq willayta ruwasqa infraestructurankupi.<br><br>

        <strong>4. Willakuypa Waqaychasqan</strong><br>
        Plataformata amachanapaqmi allin seguridad ruwaykunata ruwakun. Ichaqa manan mayqen métodopas internetnintakama apachinapaqqa llapanpi segurochu.<br><br>
    `,
    cookies_content: `
        <strong>1. Imataq Cookies chaymanta Llaqta Waqaychay?</strong><br>
        Cookies chaymanta maskaq kiti waqaychay huch'uy willay willañiqikuna dispositivopi waqaychasqa kanku ruwanakuna munasqakuna yuyarinapaq tukuy watukuykunapi.<br><br>

        <strong>2. Uso Propósito</strong><br>
        Navegador LocalStorage sinchita llamk'achkan ruwana ruwanakuna waqaychaypaq, kayhina:<br>
        - Simi munasqakuna<br>
        - Ruwaqpa interfazninpa ruwaynin (e.g., churay utaq tema churanakuna)<br>
        - Huk pachapaq ruwana cache<br><br>

        <strong>3. Mana Rastreoyuq</strong><br>
        Cookies chaymanta kiti waqaychay mana willakuypaq utaq kimsa kaqmanta qatiypaq llamk'achisqachu. Llapan waqaychasqa willakuykunaqa plataformapa ukhun ruwayninpaqmi sinchita.<br><br>

        <strong>4. Control</strong><br> nisqa
        Navegadorpa willayninkuna mayk'aqllapas ch'uyanchasqa kanman maskaqpa churanakuna kaqnintakama, mayqinchus mayqin kiti ruwanakunatapas wakmanta churanqa.
    `,
    cookie_consent_text: "Sapsi cookiekuna llamk'achiyku web kiti allin ruwayninta qhawanaykupaq, kayhina tiyayniyki ruwaq waqaychay, simi munasqaykita waqaychay chaymanta wak sapanchasqa ruwanakuna.",
    read_policy: "Ñawiriy Cookie kamachiyta",
    support_title: "Yanapakuywan rimanakuy",
    support_subject_label: "Rimana",
    support_message_label: "Willakuy",
    support_submit_button: "Willakuyta apachiy",
    support_hint: "Qhaway: Kayqa ñawpaqmanta ruwasqa correo electrónico ruwanaykita kicharinqa willayta apachinaykipaq.",
    support_success_msg: "Correo electrónico nisqa appnikita kichaspa...",
    support_error_msg: "Mana willayta apachiyta atisqachu. Ama hina kaspa, qhipaman hukmanta kallpachakuy.",
    explorer_title: "Explorador nisqa",
    history_title: "Willarina",
    animation_title: "Animación nisqa",
    config_title: "Configuración nisqa",
    tool_mouse: "Akllay (Ctrl+M) .",
    tool_brush: "Cepillo (Ctrl+B) nisqawan.",
    tool_brush_mode: "Modo de Toggle (Sólido/Ch'uya) .",
    tool_eraser: "Borrador (Ctrl+E) nisqa.",
    tool_brush_size: "Ajuste Tamaño de Pincel",
    tool_bucket: "Hunt'achiy (Ctrl+F) .",
    tool_eyedropper: "Ñawi gota",
    tool_grid: "Rejilla (Ctrl+Mayúscula+B) .",
    tool_rotate: "Muyuchiy (Ctrl+Mayúscula+R) .",
    tool_flip_h: "Flip H (Ctrl+Mayúscula+H) nisqa.",
    tool_flip_v: "V tikray (Ctrl+Mayúscula+V) .",
    tool_transpose: "Transponer (Ctrl+Mayúscula+T) nisqa.",
    label_width: "Kinray",
    label_height: "Sayay",
    label_frames: "Yupay Marcokuna",
    label_animation: "Estilo de Animación nisqa",
    label_background_color: "Fondo Color",
    label_interval: "Intervalo nisqa",
    tool_anim_config: "Animación nisqa Configuración nisqa",
    label_new_width: "Musuq Ancho",
    label_new_height: "Musuq Altura",
    label_apply: "Ruwachiy",
    label_colors: "Colores nisqakuna",
    label_size: "Sayay",
    label_tolerance: "Harkarina",
    val_horizontal: "Kinranpa",
    val_vertical: "Sayanpa",
    val_sequence: "Qati qati",
    val_bounce: "Rebote",
    val_random: "Chiripa",
    val_solid: "Rumi",
    val_clear: "Pichay",
    action_add_sheet: "Musuq Raphi",
    action_import: "Yaykuchimuy",
    action_export: "Hawaman apachiy",
    action_sort_projects: "Ñiqinchay",
    sort_date_old: "Aswan Kuraq Ñawpaq kaq",
    sort_date_new: "Aswan musuq Ñawpaq kaq",
    sort_name_az: "Suti (A-Z) .",
    sort_name_za: "Suti (Z-A) .",
    action_new_sprite: "Musuq Sprite",
    action_new_project: "Musuq Proyecto",
    modal_save_all_title: "Tukuy Tikraykunata Waqaychay",
    modal_save_all_desc: "Waqaychanaykipaq kaqniyuq kaqkunata akllay:",
    modal_save_selected: "Waqaychay Akllasqa",
    action_saved: "Waqaychasqa",
    modal_create_sprite_title: "Musuq Sprite nisqa paqarichiy",
    modal_create_project_title: "Musuq Proyectota paqarichiy",
    modal_add_sheet_title: "Musuq Raphita yapay",
    modal_rename_sheet_title: "Raphita sutichay",
    modal_rename_sprite_title: "Sprite sutiyuqta tikray",
    modal_delete_sprite_title: "Sprite nisqamanta qulluy",
    modal_delete_project_title: "Proyecto Borrar",
    modal_delete_sheet_title: "Borrar Raphi",
    placeholder_sprite_name: "Suti",
    placeholder_project_name: "Suti",
    placeholder_sheet_name: "Suti",
    placeholder_new_name: "Musuq Suti",
    action_create: "Paqarichiy",
    action_add: "Yapay",
    action_rename: "Suti tikray",
    action_duplicate: "Iskay kuti ruway",
    action_delete: "Chinkachiy",
    action_cancel: "Sayachiy",
    confirm_delete_sprite: "¿Segurochu kanki kay sprite chinkachiyta munanki?",
    confirm_delete_project: "¿Segurochu kanki kay proyectota chinkachiyta munanki? Llapan spritekuna hurqusqa kanqa.",
    confirm_delete_sheet: "¿Segurochu kanki kay raphita chinkachiyta munanki?",
    err_select_sprite: "Ama hina kaspa, ñawpaqta huk sprite nisqa akllay.",
    err_select_project: "Ama hina kaspa, ñawpaqta huk proyectota akllay.",
    err_name_empty: "Sutiqa manam ch'usaq kanmanchu.",
    err_sprite_exists: "Chay sutiyuq spriteqa kachkanñam.",
    err_project_exists: "Chay sutiyuq proyectoqa kachkanñam.",
    err_no_content: "Mana contenidota waqaychanapaq.",
    err_no_changes: "Mana tikrakuykuna waqaychaypaq.",
    err_delete_last_sheet: "Qhipa kaq raphitaqa manam qulluyta atinchu.",
    err_extract_frames: "Mana ima marcokunatapas hurquyta atirqanchu.",
    err_indexeddb: "Llaqtapi waqaychayta mana atirqanchu. Navegadorniyki mana IndexedDB yanapanmanchu.",
    msg_upload_success: "Kargayqa Allinmi: {0}",
    msg_upload_failed: "Kargayqa manam atisqachu: {0}",
    msg_save_success: "Waqaychay allin ruwasqa.",
    msg_saving: "Waqaychay...",
    msg_multi_save_result: "Waqaychasqa {0} kaqniyuq. {1} mana allinkuna.",
    menu_title: "Menú nisqa",
    menu_save: "Waqaychay",
    menu_save_all: "Llapanta Waqaychay",
    menu_support: "Yanapakuywan rimanakuy",
    label_local_storage: "Llaqta Waqaychasqa",
    label_sign_in: "Yaykuy",
    modal_export_title: "Sprite nisqa hawa llaqtakunaman apachiy",
    label_filename: "Willañiqi suti",
    label_format: "Formato nisqa",
    action_export_confirm: "Hawaman apachiy",
};

export default translations;
